__turbopack_context__.v({
  "counter": "SearchCartControl-module-scss-module__yQfySG__counter",
  "value": "SearchCartControl-module-scss-module__yQfySG__value",
});
